"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.CommonCta = void 0;
var _commonCta = _interopRequireDefault(require("./components/common-cta"));
exports.CommonCta = _commonCta["default"];